// extracted by mini-css-extract-plugin
export var container = "_1h-0";
export var disabled = "_1h-4";
export var fullWidth = "_1h-3";
export var lined = "_1h-1";
export var selected = "_1h-5";
export var tab = "_1h-2";